import {
  useFeatureFlagStore,
  type FeatureFlag,
} from '@/shared/stores/featureFlags'

export const useFeatureFlag = (flag: FeatureFlag) => {
  return useFeatureFlagStore().useFlag(flag)
}
